import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { useFavorites } from "../../context/FavoritesContext";
import { useCart } from "../../context/CartContext";
import { FEATURES } from "../../config/features";

// Fixed bottom-left companion to the back-to-top button. Shows the
// favorites and order-request counts with quick links.
// Hidden while the client keeps these features off the public site.
export default function FloatingTray() {
  const fav = useFavorites();
  const cart = useCart();

  if (!FEATURES.favorites && !FEATURES.orderRequests) return null;
  if (!fav.items.length && !cart.count) return null;

  return (
    <div className="fixed bottom-6 left-6 z-[55] flex items-center gap-2" data-testid="floating-tray">
      {FEATURES.favorites && fav.items.length > 0 && (
        <Link
          to="/favorites"
          data-testid="floating-favorites"
          className="relative inline-flex items-center gap-2 h-11 pl-3 pr-4 bg-[#F6F2EC] text-[#252525] border border-black/10 shadow-sm hover:border-[#D92A47] transition-colors"
        >
          <Heart size={16} strokeWidth={1.6} className="text-[#D92A47]" fill="#D92A47" />
          <span className="text-xs font-semibold tracking-[0.14em] uppercase">
            Favorites · {fav.items.length}
          </span>
        </Link>
      )}
      {FEATURES.orderRequests && cart.count > 0 && (
        <Link
          to="/order-request"
          data-testid="floating-order"
          className="inline-flex items-center gap-2 h-11 pl-3 pr-4 bg-[#D92A47] text-[#F6F2EC] hover:bg-[#b71e3a] transition-colors"
        >
          <ShoppingBag size={16} strokeWidth={1.6} />
          <span className="text-xs font-semibold tracking-[0.14em] uppercase">
            Request · {cart.count}
          </span>
        </Link>
      )}
    </div>
  );
}
